import React from 'react';

import ColorButtonComponent from '@/components/common/elements/ColorButton/ColorButtonComponent';

const ColorButtonContainer = ({ ...props }) => <ColorButtonComponent {...props} />;

export default ColorButtonContainer;
